module.exports = __webpack_public_path__ + "static/media/TheConversation.80dede38.jpg";